<template>
    <div class="content">
        <div class="md-layout">
            <div class="md-layout-item">
                <md-card>
                    <md-card-header class="md-card-header-icon md-card-header-warning">
                        <div class="card-icon">
                            <md-icon>receipt</md-icon>
                        </div>
                    </md-card-header>
                    <md-card-content class="body-list">
                        <div
                            v-if="
                                showProgressBox &&
                                    selectedTeamMemberInvoiceIds != null &&
                                    selectedTeamMemberInvoiceIds.length > 0
                            "
                            class="bulk-section"
                        >
                            <div>Cannot perform bulk operations while generating invoice.</div>
                        </div>
                        <div
                            class="bulk-section"
                            v-if="selectedMessage && (!showProgressBox || isProgressComplete) && !isTeamMember"
                        >
                            <div>{{ selectedMessage }} invoice{{ selectedMessage > 1 ? 's' : '' }} selected.</div>
                            <div>
                                <payment-status-button
                                    :is-bulk="true"
                                    @invoiceBulkStatusUpdate="handleBulkChangeStatus"
                                    :bulk-team-member-invoice-ids="selectedTeamMemberInvoiceIds"
                                />
                                <md-button
                                    v-if="hasAccountingPackage"
                                    class="md-round md-just-icon md-warning"
                                    title="Send to Accounting Package"
                                    @click="handleSendToAccountingPackageClick"
                                >
                                    <md-icon>send</md-icon>
                                </md-button>
                                <send-email-button
                                    :is-bulk="true"
                                    :bulk-team-member-invoice-ids="selectedTeamMemberInvoiceIds"
                                    @handleBulkSent="handleBulkSentEmail"
                                />
                                <delete-invoice-button
                                    :is-bulk="true"
                                    :bulk-team-member-invoice-ids="selectedTeamMemberInvoiceIds"
                                    @invoiceBulkDelete="handleBulkDelete"
                                />
                            </div>
                        </div>
                        <div :key="updateList">
                            <md-table
                                :class="[
                                    'context-menu-support',
                                    'custom-paginated-table',
                                    { 'table-margin': isListLoading }
                                ]"
                            >
                                <md-table-row>
                                    <md-table-head>
                                        <md-checkbox
                                            class="shipment-checkbox checkbox-head"
                                            v-model="isSelectAll"
                                            @change="onSelectAll(isSelectAll)"
                                        ></md-checkbox>
                                    </md-table-head>
                                    <md-table-head v-if="!$root.isDesktop">Status</md-table-head>
                                    <md-table-head>Invoice Number</md-table-head>
                                    <md-table-head v-if="$root.isDesktop">Team Member</md-table-head>
                                    <md-table-head v-if="$root.isDesktop">Invoice Date</md-table-head>
                                    <md-table-head v-if="$root.isDesktop">Due Date</md-table-head>
                                    <md-table-head md-numeric v-if="$root.isDesktop">Subtotal</md-table-head>
                                    <md-table-head md-numeric v-if="$root.isDesktop">Tax</md-table-head>
                                    <md-table-head md-numeric>Total Amount</md-table-head>

                                    <md-table-head v-if="$root.isDesktop">Status</md-table-head>
                                    <md-table-head v-if="$root.isDesktop && !isReadOnlyUser">Actions</md-table-head>
                                </md-table-row>
                                <md-table-row
                                    v-for="invoice in invoicesList"
                                    :key="invoice.teamMemberInvoiceId"
                                    @click.stop="showSidebar(invoice.teamMemberInvoiceId)"
                                >
                                    <md-table-cell>
                                        <md-checkbox
                                            class="shipment-checkbox"
                                            :value="invoice.teamMemberInvoiceId"
                                            v-model="selectedTeamMemberInvoiceIds"
                                        ></md-checkbox>
                                    </md-table-cell>
                                    <md-table-cell v-if="!$root.isDesktop">
                                        <payment-status-button
                                            :show-mobile-style="true"
                                            :invoice-details="invoice"
                                            @statusUpdated="onChangedInvoiceStatus"
                                        />
                                    </md-table-cell>
                                    <md-table-cell>
                                        <router-link
                                            class="invoice-ref"
                                            :to="{
                                                name: 'Team Member Invoice Details',
                                                params: { invoiceId: invoice.teamMemberInvoiceId }
                                            }"
                                            target="_blank"
                                        >
                                            {{ invoice.invoiceNumber }}
                                        </router-link>
                                    </md-table-cell>
                                    <md-table-cell v-if="$root.isDesktop">
                                        {{ invoice.teamMember.fullName }}
                                    </md-table-cell>

                                    <md-table-cell v-if="$root.isDesktop">
                                        {{ invoice.invoiceDate | dateFormat(DATE_TYPES.standardDate) }}
                                    </md-table-cell>
                                    <md-table-cell v-if="$root.isDesktop">
                                        {{ invoice.dueDate | dateFormat(DATE_TYPES.standardDate) }}
                                    </md-table-cell>
                                    <md-table-cell md-numeric v-if="$root.isDesktop">
                                        {{ invoice.subTotal | currency(invoice.currency) }}
                                    </md-table-cell>
                                    <md-table-cell md-numeric v-if="$root.isDesktop">
                                        {{ invoice.totalTax | currency(invoice.currency) }}
                                    </md-table-cell>
                                    <md-table-cell md-numeric>
                                        {{ invoice.total | currency(invoice.currency) }}
                                    </md-table-cell>

                                    <md-table-cell v-if="$root.isDesktop">
                                        <payment-status-button
                                            :invoice-details="invoice"
                                            @statusUpdated="onChangedInvoiceStatus"
                                        />
                                    </md-table-cell>

                                    <md-table-cell v-if="$root.isDesktop && !isReadOnlyUser" class="action-buttons">
                                        <sync-invoice-button
                                            :invoice="invoice"
                                            v-if="hasAccountingPackage && !isTeamMember"
                                        />
                                        <generate-pdf-button
                                            v-if="!isReadOnlyUser"
                                            :invoice-id="invoice.teamMemberInvoiceId"
                                        />
                                        <generate-excel-button
                                            v-if="!isReadOnlyUser"
                                            :invoice-id="invoice.teamMemberInvoiceId"
                                        />
                                        <template v-if="!hasFeatureTeamMemberInvoiceDraftApproval">
                                            <send-email-button
                                                v-if="!isReadOnlyUser && !isTeamMember"
                                                :invoice-id="invoice.teamMemberInvoiceId"
                                                :email-sent-date="invoice.lastEmailDateSent"
                                                @invoiceSent="handleSentEmail"
                                            />
                                        </template>
                                        <template v-else>
                                            <send-email-button
                                                v-if="!isReadOnlyUser && !isTeamMember && hasFeatureTeamMemberInvoiceDraftApproval && invoice.teamMember.shouldApplyTax"
                                                :invoice-id="invoice.teamMemberInvoiceId"
                                                :email-sent-date="invoice.lastEmailDateSent"
                                                @invoiceSent="handleSentEmail"
                                            />
                                        </template>

                                        <delete-invoice-button
                                            v-if="!isTeamMember"
                                            :invoice-id="invoice.teamMemberInvoiceId"
                                            @invoiceDeleted="handleDeleteInvoice"
                                        />
                                    </md-table-cell>
                                </md-table-row>
                                <md-table-row v-if="totals && invoicesList.length > 0">
                                    <md-table-cell></md-table-cell>
                                    <md-table-cell v-if="!$root.isDesktop"></md-table-cell>
                                    <md-table-cell class="totals-bold">Totals</md-table-cell>
                                    <md-table-cell v-if="$root.isDesktop"></md-table-cell>
                                    <md-table-cell v-if="$root.isDesktop"></md-table-cell>
                                    <md-table-cell v-if="$root.isDesktop"></md-table-cell>
                                    <md-table-cell v-if="$root.isDesktop" md-numeric class="totals-bold">
                                        {{
                                            totals.subTotal
                                                | currency(invoicesList.length > 0 ? invoicesList[0].currency : null)
                                        }}
                                    </md-table-cell>
                                    <md-table-cell v-if="$root.isDesktop" md-numeric class="totals-bold">
                                        {{
                                            totals.totalTax
                                                | currency(invoicesList.length > 0 ? invoicesList[0].currency : null)
                                        }}
                                    </md-table-cell>
                                    <md-table-cell md-numeric class="totals-bold">
                                        {{
                                            totals.total
                                                | currency(invoicesList.length > 0 ? invoicesList[0].currency : null)
                                        }}
                                    </md-table-cell>
                                    <md-table-cell v-if="$root.isDesktop"></md-table-cell>
                                    <md-table-cell v-if="$root.isDesktop && !isReadOnlyUser"></md-table-cell>
                                </md-table-row>
                            </md-table>
                            <div v-if="invoicesList.length == 0 && !isListLoading">
                                <p class="no-result-message">No results matching your search/filter could be found.</p>
                            </div>
                            <div v-if="isListLoading" class="content-loader loading-position">
                                <fade-loader :loading="isListLoading" color="#333333" />
                                <span>LOADING</span>
                            </div>
                        </div>
                    </md-card-content>
                </md-card>
                <md-card-actions class="page-footer" md-alignment="space-between" v-if="total >= pagination.perPage">
                    <div class>
                        <p class="card-category">Showing page {{ pagination.currentPage }} of {{ maxPage }}</p>
                    </div>
                    <pagination
                        v-model="pagination.currentPage"
                        class="pagination-no-border pagination-success"
                        :per-page="pagination.perPage"
                        :total="total"
                        @change-page="handleChangePage($event, pagination.perPage)"
                    />
                </md-card-actions>
            </div>

            <transition name="slide">
                <team-member-invoices-sidebar
                    v-if="isShowSidebar"
                    :team-member-invoice-id="teamMemberInvoiceId"
                    v-click-outside="toggleSidebarWindow"
                    @closeModal="toggleSidebarWindow"
                />
            </transition>
        </div>
    </div>
</template>

<style scoped>
.totals-bold {
    font-weight: 600;
}
</style>

<script>
import { PAGINATION_DEFAULTS } from '@/utils/defaults';
import { handleRequests, showErrorMessage } from '@/helpers';
import { GeneralMixin } from '@/mixins/GeneralMixin';
import FadeLoader from 'vue-spinner/src/FadeLoader';
import { mapGetters } from 'vuex';
import { Pagination } from '@/components';
import { FeatureManager } from '@/directives';
import { DATE_TYPES, SEND_TO_ACCOUNTING_CONSTANTS, FEATURE_NAMES } from '@/utils/constants';
import moment from 'moment';
import TeamMemberInvoicesSidebar from './TeamMemberInvoicesSidebar';
import {
    SyncInvoiceButton,
    GeneratePdfButton,
    GenerateExcelButton,
    SendEmailButton,
    PaymentStatusButton,
    DeleteInvoiceButton
} from './buttons';

export default {
    name: 'TeamMemberInvoicesOverview',
    mixins: [GeneralMixin, FeatureManager],
    components: {
        FadeLoader,
        TeamMemberInvoicesSidebar,
        Pagination,
        SyncInvoiceButton,
        GeneratePdfButton,
        GenerateExcelButton,
        SendEmailButton,
        PaymentStatusButton,
        DeleteInvoiceButton
    },
    props: {
        filters: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            invoicesList: [],
            isListLoading: false,
            pagination: PAGINATION_DEFAULTS,
            maxPage: 1,
            isShowSidebar: false,
            teamMemberInvoiceId: null,
            selectedFile: null,
            hasError: false,
            errorMessages: [],
            updateList: 0,
            selectedTeamMemberId: '',
            selectedTeamMemberInvoiceIds: [],
            isSelectAll: false,
            isProcessAll: false,
            batchFilterList: [],
            showProgressBox: false,
            isProgressComplete: false,
            totals: null,
            FEATURE_NAMES
        };
    },
    computed: {
        currentPageMax() {
            const highBound = this.currentPageMin + this.pagination.perPage;
            return this.total < highBound ? this.total : highBound;
        },
        currentPageMin() {
            return this.pagination.perPage * (this.pagination.currentPage - 1);
        },
        total() {
            return this.pagination.total;
        },
        totalPages() {
            if (this.total > 0) {
                return Math.ceil(this.total / this.pagination.perPage);
            }
            return 1;
        },
        ...mapGetters({
            user: 'user/user',
            isReadOnlyUser: 'user/isReadOnlyUser',
            hasAccountingPackage: 'generalSetting/hasAccountingPackage',
            isTeamMember: 'user/isTeamMember'
        }),
        selectedMessage() {
            return this.selectedTeamMemberInvoiceIds.length;
        },
        hasFeatureTeamMemberInvoiceDraftApproval() {
            return this.$_hasFeature(FEATURE_NAMES.TeamMemberInvoiceDraftApproval) && this.$_hasFeature(FEATURE_NAMES.DraftInvoices);
        }
    },
    watch: {
        selectedTeamMemberInvoiceIds: {
            handler() {
                // Force parent to update when selection changes
                this.$emit('selectionChanged', this.selectedTeamMemberInvoiceIds.length);
            },
            deep: true
        },
        invoicesList: {
            handler() {
                // Force parent to update when list changes
                this.$emit('listChanged', this.invoicesList.length);
            },
            deep: true
        }
    },
    async mounted() {
        this.isListLoading = true;
        await this.$store.dispatch('generalSetting/FETCH_TEAM_ACCOUNTING_PACKAGE');
        this.filters.teamRegionId = null; // All

        const currentPage = Number(this.$route.query.currentPage) || 1;
        if (currentPage) {
            this.pagination.currentPage = currentPage;
        }

        await this.handleChangePage(currentPage, this.pagination.perPage);
    },
    methods: {
        onChangedInvoiceStatus(response) {
            const { teamMemberInvoiceId, status } = response;
            const invoice = this.invoicesList.find((item) => item.teamMemberInvoiceId === teamMemberInvoiceId);
            this.$set(invoice, 'status', status);
        },
        sendToAccountingPackage() {},
        async handleSyncInvoice(item) {
            if (item.isSyncing === undefined) {
                this.$set(item, 'isSyncing', true);
            } else {
                item.isSyncing = true;
            }

            try {
                const endpoint = `/api/team-member-invoices/send-to-accounting`;
                const data = {
                    invoiceIdList: [item.teamMemberInvoiceId]
                };
                const payload = {
                    method: 'post',
                    data
                };
                await handleRequests(endpoint, payload);
            } catch (error) {
                item.isSyncing = false;
            }
        },
        onSelectAll(value) {
            if (value) {
                this.invoicesList.forEach((invoice) => {
                    this.selectedTeamMemberInvoiceIds.push(invoice.teamMemberInvoiceId);
                });
            } else {
                this.selectedTeamMemberInvoiceIds = [];
            }
        },
        async getInvoicesList(pageNumber = 1, invoicesPerPage = 50) {
            try {
                this.isListLoading = true;
                const endpoint = `/api/team-member-invoices/search`;
                const response = await handleRequests(endpoint, {
                    params: {
                        pageNumber,
                        invoicesPerPage,
                        ...this.cleanFilters()
                    }
                });

                const { invoices, totalInvoices, batchFilters } = response.data;

                this.batchFilterList = batchFilters.map((item) => {
                    return { id: item.invoiceBatchId, label: this.formatDate(item.startDate, item.endDate) };
                });

                this.$emit('batchFilterUpdated', this.batchFilterList);

                this.invoicesList = invoices;

                // Prevent sending of individual invoice to accounting package if there was a recent unfinished last sync attempt
                for (let i = 0; i < this.invoicesList.length; i++) {
                    const invoice = this.invoicesList[i];

                    if (
                        invoice.accountingSystemLastSyncAttemptDate &&
                        !invoice.accountingSystemRef &&
                        !invoice.accountingSystemNote
                    ) {
                        const now = moment.utc();
                        const accountingSystemLastSyncAttemptDate = moment.utc(
                            invoice.accountingSystemLastSyncAttemptDate
                        );

                        if (
                            now.diff(accountingSystemLastSyncAttemptDate, 'minutes') <
                            SEND_TO_ACCOUNTING_CONSTANTS.enableRetryAfterMinutes
                        ) {
                            invoice.isSyncing = true;
                            invoice.retryTooltip = 'Sending is still in progress. Please check again later.';
                        }
                    }
                }

                this.pagination.total = totalInvoices || this.invoicesList.length;
                this.maxPage = Math.ceil(this.pagination.total / this.pagination.perPage);
            } catch (error) {
                const message = 'Error in getting the team member invoice list';
                showErrorMessage(this, message, error);
            }
            try {
                const hasBatchFilter = !!this.filters?.teamMemberInvoiceBatchId;
                if (hasBatchFilter) {
                    await this.getTotals();
                } else {
                    this.totals = null;
                }
            } catch (e) {
                this.totals = null;
            }
            this.isListLoading = false;
        },
        async getTotals() {
            const endpoint = `/api/team-member-invoices/totals`;
            const response = await handleRequests(endpoint, {
                params: {
                    ...this.cleanFilters()
                }
            });
            this.totals = response?.data || null;
        },
        formatDate(startDate, endDate) {
            const formattedStartDate = this.$options.filters.dateFormat(startDate, DATE_TYPES.standardDate);
            const formattedEndDate = this.$options.filters.dateFormat(endDate, DATE_TYPES.standardDate);

            return `${formattedStartDate} - ${formattedEndDate}`;
        },
        cleanFilters() {
            Object.keys(this.filters).forEach((e) => {
                if (!this.filters[e])
                    this.filters[e] = null;
                if (this.filters[e] === '' || this.filters[e] === null)
                    delete this.filters[e];
            });

            return this.filters;
        },
        async handleChangePage(currentPage = 1, perPage = 50) {
            this.invoicesList = [];

            this.pagination.currentPage = currentPage;
            this.pagination.perPage = perPage;
            this.$router.replace({ path: this.$route.path, query: { currentPage } });
            await this.getInvoicesList(currentPage, perPage);
        },
        showSidebar(id) {
            this.isShowSidebar = true;
            this.teamMemberInvoiceId = id;
        },
        toggleSidebarWindow() {
            if (!this.$modal.isModalShown && !this.$messageBox.isMessageBoxShown)
                this.isShowSidebar = !this.isShowSidebar;
        },
        async handleSendToAccountingPackageClick() {
            this.isProcessAll = true;
            this.$_handleLoaderState(true, 'SENDING...');
            this.selectedTeamMemberInvoiceIds.forEach((invoiceId) => {
                const invoice = this.invoicesList.find((x) => x.teamMemberInvoiceId === invoiceId);

                if (invoice.isSyncing === undefined) {
                    this.$set(invoice, 'isSyncing', true);
                } else {
                    invoice.isSyncing = true;
                }
            });

            try {
                const endpoint = `/api/team-member-invoices/send-to-accounting`;
                const data = {
                    invoiceIdList: this.selectedTeamMemberInvoiceIds
                };
                const payload = {
                    method: 'post',
                    data
                };
                await handleRequests(endpoint, payload);
            } catch (error) {
                this.isProcessAll = false;
                this.$_handleLoaderState(false);
                const message = 'Error in sending the invoices to the accounting package';
                showErrorMessage(this, message, error);
                this.selectedTeamMemberInvoiceIds.forEach((invoiceId) => {
                    const invoice = this.invoicesList.find((x) => x.teamMemberInvoiceId === invoiceId);
                    invoice.isSyncing = false;
                });
            }
        },
        removeSelected(invoiceId) {
            const ndx = this.selectedTeamMemberInvoiceIds.findIndex((x) => x === invoiceId);
            if (ndx > -1) {
                this.selectedTeamMemberInvoiceIds.splice(ndx, 1);
                this.isSelectAll = false;
            }
        },
        handleBulkDelete({ result, ids }) {
            const invoices = [...ids];
            if (result) {
                invoices.forEach((invoiceId) => {
                    this.removeSelected(invoiceId);
                });

                this.handleChangePage(true);
            } else {
                const message = 'There was an error deleting the invoices';
                showErrorMessage(this, message);
            }
        },
        handleBulkChangeStatus(response) {
            if (response) {
                this.handleChangePage(1, this.pagination.perPage);
            }
        },
        handleDeleteInvoice({ result, invoiceId }) {
            this.removeSelected(invoiceId);
            if (result) {
                this.handleChangePage(1, this.pagination.perPage);
            }
        },
        handleSentEmail(invoiceId) {
            const invoice = this.invoicesList.find((x) => x.teamMemberInvoiceId === Number(invoiceId));
            if (invoice) {
                invoice.lastEmailDateSent = moment().format();
            }
        },
        handleBulkSentEmail(invoiceIdList) {
            invoiceIdList.forEach((invoiceId) => {
                this.handleSentEmail(invoiceId);
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.no-result-message {
    text-align: center;
    margin-top: 45px;
    font-size: 16px;
}

::v-deep .md-numeric {
    .md-table-cell-container {
        padding-right: 10px;
    }
}

::v-deep .status-container {
    .md-table-cell-container {
        overflow: visible;
    }
}

::v-deep .rating-container {
    .ratings {
        display: flex;
        align-items: flex-end;

        > {
            display: inline-block;
        }

        .md-icon {
            margin: 0;
        }
    }
}

.slide-leave-active,
.slide-enter-active {
    transition: 0.3s;
}

.slide-enter {
    transform: translateX(100%);
}

.slide-leave-to {
    transform: translateX(100%);
}

.content {
    margin-top: -15px;

    ::v-deep .md-card.md-theme-default {
        margin-bottom: 0;
    }
}

::v-deep .md-table-cell-container {
    .md-button.md-round.md-just-icon {
        box-shadow: none;
    }
}

.custom-hidden-tablet {
    display: none;
}

.address-container {
    display: none;
}

@media (min-width: 1400px) {
    .address-container {
        display: table-cell;

        ::v-deep .md-table-cell-container {
            max-width: 300px;
        }
    }
}

::v-deep .md-table-cell {
    padding: 0px 8px;

    &:last-child {
        .md-table-cell-container {
            text-align: left !important;
            justify-content: flex-start;
        }
    }
}

::v-deep .md-table-row {
    &.zero-results {
        padding: 16px;
        text-align: center;
    }

    .custom-button-container .custom-a-blue a {
        color: rgba(0, 0, 0, 0.87);
    }
}

::v-deep .md-table-row:hover {
    background-color: #fafafa;
    cursor: pointer;
}

::v-deep .md-toolbar {
    .md-field {
        &:first-child,
        &:last-child {
            margin: 8px;
        }
    }

    .stops-search {
        padding-bottom: 10px;

        &::before,
        &::after {
            bottom: 10px;
        }
    }
}

::v-deep .md-card-actions {
    padding: 16px;

    &.page-footer {
        padding-top: 0px;
    }
}

.stop-reference ::v-deep a {
    color: rgba(0, 0, 0, 0.87);
}

::v-deep .header-button {
    width: 32px;
    height: 32px;
    min-width: 32px;
}

.gray-text {
    color: rgba(0, 0, 0, 0.5);
}

.profile-image {
    height: 30px;
    width: 30px;
    border-radius: 50%;
    margin-right: 5px;
}

.loader {
    position: absolute;
    top: 40%;
    left: 50%;

    span {
        position: absolute;
        margin-top: 50px;
        width: 110px;
        left: calc((100% - 100px) / 2);
        text-align: center;
        font-weight: 600;
    }
}

::v-deep .md-table-head-label {
    color: #4caf50 !important;
}

.action-buttons {
    button,
    ::v-deep button {
        margin: 0 2px;
    }

    button:last-child {
        margin-right: 0;
    }
}

.assigned-column {
    display: inline-block;
    vertical-align: middle;

    ::v-deep .custom-ellipsis {
        max-width: 150px;
    }
}

.stop-checkbox {
    margin: 0;
}

.checkbox-head {
    margin-top: 4px;
}

.body-list {
    position: relative;

    .sticky {
        position: fixed;
        top: 0;
        z-index: 9;
        left: 75px;
    }
}

.icon-warning {
    color: #ff9800 !important;
    cursor: pointer;
    left: 14px;
}

.bulk-section {
    position: absolute;
    top: -35px;
    width: 700px;
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
    text-align: center;
    background-color: #cfeefa;
    color: #2b93ff;
    font-weight: 400;
    padding: 5px 10px 5px 20px;
    > div {
        width: 40%;
        display: inline-block;
        vertical-align: middle;
        text-align: left;
    }
    > div:last-child {
        width: 60%;
        text-align: right;
        button {
            height: 30px;
            width: 30px;
            min-width: 30px;
        }
        .dropdown {
            width: 180px;
            background-color: #ff9800 !important;
            display: inline-block;
            text-align: center;
            color: #fff;
            text-transform: uppercase;
            font-size: 12px;
            height: 30px;
            line-height: 30px;
            margin-top: 6px;
            cursor: pointer;
        }
    }
}

@media (max-width: 992px) {
    .tablet-button-margin {
        margin-right: 10px;
    }
}

.green-flag {
    ::v-deep i {
        color: green !important;
    }
}

.custom-badge {
    max-width: initial;
}

.invoice-ref {
    color: rgba(0, 0, 0, 0.87) !important;
}

.invoice-ref:hover {
    color: #2b93ff !important;
}

.info-icons {
    display: inline-block;
}

.error-icon i {
    color: #f44336 !important;
}

.content {
    position: relative !important;
    height: 100% !important;
    min-height: 95vh !important;
}

.table-margin {
    margin-bottom: 200px !important;
}

.loading-position {
    left: 50%;
    top: 50%;
}
</style>
